module.exports = __webpack_public_path__ + "img/couples-009.b1779b0c.jpg";